import { resolveApiUrl, resolveBaseUrl, resolveCdnUrl } from "./env";

const base = {
  apiUrl: resolveApiUrl(),
  baseUrl: resolveBaseUrl(),
  cdnUrl: resolveCdnUrl(),
};

export default base;
